import { Form, type FormListFieldData, Input } from 'ui';
import { BulkInput } from '../bulk-input';
import { TaskInput } from '../task-input';

type P = {
  disabledEdit: boolean;
  field: FormListFieldData;
};

const TaskSwitch = ({ disabledEdit, field }: P) => {
  switch (field.name) {
    case 0:
      return (
        <>
          <TaskInput
            disabledEdit={disabledEdit}
            field={field}
            item={{ label: 'Activity name' }}
            placeholder="What is expected? (e.g.:select the activity you did today)"
          />
          <BulkInput
            disabledEdit={disabledEdit}
            field={field}
            item={{ extra: 'Divide items by commas', label: 'List of options' }}
            placeholder="Define options... (e.g..: run, walk, bike, jogging)"
          />
          {/* eslint-disable-next-line no-restricted-syntax -- We cannot type it, because name is dynamic */}
          <Form.Item hidden name={[field.name, 'kind']} noStyle>
            <Input />
          </Form.Item>
        </>
      );
    case 1:
      return (
        <>
          <BulkInput
            disabledEdit={disabledEdit}
            field={field}
            item={{ extra: 'Divide items by commas', label: 'List of units' }}
            placeholder="Define units... (e.g.: minutes, lbs, miles)"
          />
          {/* eslint-disable-next-line no-restricted-syntax -- We cannot type it, because name is dynamic */}
          <Form.Item hidden name={[field.name, 'input']} noStyle>
            <Input />
          </Form.Item>
          {/* eslint-disable-next-line no-restricted-syntax -- We cannot type it, because name is dynamic */}
          <Form.Item hidden name={[field.name, 'name']} noStyle>
            <Input />
          </Form.Item>
          {/* eslint-disable-next-line no-restricted-syntax -- We cannot type it, because name is dynamic */}
          <Form.Item hidden name={[field.name, 'kind']} noStyle>
            <Input />
          </Form.Item>
        </>
      );
    default:
      return null;
  }
};

export default TaskSwitch;
